<template>
  <div id="app">
    <app-header-inmate
      :app-title="$t('title')"
      :app-subtitle="$t('subtitle')"
    >
      <ul class="is-mobile-only">
        <li
          v-for="(item, index) in footerLinks"
          :key="index"
          class="mobile-menu-text"
        >
          <a
            :href="item.href"
            :target="item.target"
          >
            {{ item.text }}
          </a>
        </li>
      </ul>
    </app-header-inmate>
    <main class="container main">
      <router-view
        :focused-field="focusedField"
        :focused-class="focusedClass"
      />

      <!-- Resources Message -->
      <callout
        :message="$t('resources').text"
        class="border-none message-padding"
      />
      <ul id="list-cirlces">
        <i18n
          path="resources.li1.text"
          tag="li"
        >
          <b><a
            place="0"
            :href="'tel:+12156858394'"
            target="'_blank'"
          >{{ $t('resources.li1.link1') }}</a></b>
          <b><a
            place="1"
            :href="'tel:+12156858395'"
            target="'_blank'"
          >{{ $t('resources.li1.link2') }}</a></b>
          <b><a
            place="2"
            :href="'tel:+12156858396'"
            target="'_blank'"
          >{{ $t('resources.li1.link3') }}</a></b>
          <b><a
            place="3"
            :href="'tel:+12156858392'"
            target="'_blank'"
          >{{ $t('resources.li1.link4') }}</a></b>
        </i18n>
        <i18n
          path="resources.li2.text"
          tag="li"
        >
          <b><a
            place="0"
            :href="'tel:+12156857288 '"
            target="'_blank'"
          >{{ $t('resources.li2.link1') }}</a></b>
          <b><a
            place="1"
            :href="'tel:+12156857711'"
            target="'_blank'"
          >{{ $t('resources.li2.link2') }}</a></b>
          <b><a
            place="2"
            :href="'tel:+12156858909'"
            target="'_blank'"
          >{{ $t('resources.li2.link3') }}</a></b>
        </i18n>
      </ul>

      <!-- Related Content Message -->
      <callout
        :message="$t('related').text"
        class="border-none message-padding"
      />
      <ul id="list-cirlces">
        <li>
          <b>
            <i18n
              path="related.li1"
              tag="a"
              target="_blank"
              href="https://www.phila.gov/services/crime-law-justice/prisons-incarcerated-people-and-returning-citizens/finding-and-contacting-incarcerated-people/visit-an-incarcerated-person/"
            />
          </b>
        </li>
        <li>
          <b>
            <i18n
              path="related.li2"
              tag="a"
              target="_blank"
              href="https://www.phila.gov/services/crime-law-justice/prisons-incarcerated-people-and-returning-citizens/finding-and-contacting-incarcerated-people/contact-an-incarcerated-person-by-mail/"
            />
          </b>
        </li>
        <i18n
          path="related.li3.text"
          tag="li"
        >
          <b>
            <a
              place="0"
              :href="'https://www.phila.gov/prisons/Facilities/Pages/default.aspx'"
              target="'_blank'"
            >
              {{ $t('related.li3.link') }}
            </a>
          </b>
        </i18n>
      </ul>
    </main>
    <app-footer :links="footerLinks" />
  </div>
</template>

<script>

import axios from 'axios';
import AppHeaderInmate from './components/AppHeaderInmate/AppHeaderInmate';

export default {
  name: 'App',
  components: {
    AppHeaderInmate,
  },
  data() {
    return {
      focusedFields: [],
    };
  },
  computed: {
    focusedClass() {
      // console.log("focusedFields: ", this.focusedFields)
      return this.focusedFields === "PID" ? true : false;
    },
    focusedField() {
      // console.log("focusedFields: ", this.searchData)
      return this.searchData.PID.length > 0 ? "PID" :
        this.searchData.FirstName.length > 0 ? "Name" :
          this.searchData.LastName.length > 0 ? "Name" :
            this.searchData.birthdate.length > 0 ? "Name" :
              false;
    },
    footerLinks() {
      return [
        {
          text: this.$i18n.t("footerCity"),
          href: "https://www.phila.gov",
          type: 'native', //any other html anchor attributes
          attrs: { target: "_blank" },
        },
        {
          text: this.$i18n.t("footerPrisons"),
          href: "https://www.phila.gov/prisons",
          type: 'native', //any other html anchor attributes
          attrs: { target: "_blank" },
        },
        {
          text: this.$i18n.t("feedback"),
          href: "https://danlopez663093.typeform.com/to/uCWSCv",
          type: 'native', //any other html anchor attributes
          attrs: { target: "_blank" },
        },
      ];
    },
    searchParams() {
      return this.$store.state.searchParams;
    },
    displayLayout() {
      if (this.searchResults === false) {
        return 'error';
      } else if (this.searchResults.length > 0 && this.searchResults[0] != false) {
        // console.log("dsplayLayout search results: ", this.searchResults[0]);
        return 'results';
      } else if (this.displayStatus != 'error') {
        return 'form';
      }
      return 'error';
    },
  },
  beforeCreate() {
    this.$store.dispatch('getStatus');
  },
};
</script>

<style lang="scss">

@import "./assets/scss/main.scss";
.is-mobile-only {
  display: none;
}

@media screen and (max-width: $tablet) {

  .is-mobile-only {
    display: block;
  }

  .search-results-container.border-left {
      border-left: none !important;
    }

  .navbar {
    h2.is-size-5  {
      font-size: 13px !important;
      letter-spacing: 2.5px;
      font-weight: 200;
      display: unset !important;
    }
  }

  #app main.main {
    margin:  1rem !important;
    width: auto;
  }

  .mobile-menu-text {
    top: 15%;;
    padding-top: 20px !important;
    font-style: normal;
    font-weight: normal !important;
  }

  .navbar-brand {
    float: left;
  }

  .navbar-item {
    display: inline-flex !important;
    >a {
      display: none;
    }
  }

  #app {
    padding-bottom: unset;
  }

  #app>footer {
    >div {
      display: none;
    }
  }

  .fa-exclamation-triangle {
    display: block;
    padding-bottom: 10px;
  }

  .level-item ul {
    text-align: center;
    top: 25%;
    left: 12.5%;
    position: fixed;
  }

  .level-right {
    height: 100vh;
  }

  .or {
    clear: both;
  }

  .text-div.column.is-1.center-text {
    margin-top: -1rem;
  }

  .border>.box-text {
    padding-bottom: unset;
  }

  main .text-div {
    display: block !important;
    .input-wrap {
      padding-top: 15px;
    }
  }

  ul#list-cirlces {
    padding: 0 10px 0 17px !important;
    li {
      padding-bottom: 15px;
    }
  }
}

@media screen and (min-width: $tablet) {
  main {
    max-width: 1315px;
    margin: auto;
  }

  footer {
    left: auto;
  }

  header, .search-input-container {
    padding: 0 15px;
  }
}

.message-padding {
  margin-top: 40px;
}

.navbar-item img {
  padding-right: 10px;
}

h2.is-size-5  {
  display: none;
}



input-text {
  width: 100%;
}

.icon {
  margin-right: 20px;
  vertical-align: middle;
}

.border {
  height: 100%;
  border: .75px solid;
  margin-bottom: .5rem
}

.border-left {
  border-left: 3px solid $grey-medium;
  padding-left: 1em
}

.border-none {
  .message-body {
  border: unset;
  font-size: 1.25em;
  padding: .5em;
  background-color: $ghost-grey;
  }
}

.bottom-padding {
  padding-bottom: 2.5rem;
}

.box-text {
  font-size: 1rem;
  line-height: 130%;
  padding-bottom: 1.25rem;
}

.center-text {
  font-size: 24pt;
  text-align: center;
}

.fade {
  opacity: 0.3;
}

footer div {
  position: relative;
  overflow: hidden;
}

 footer ul {
   display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}

footer li {
  flex-grow: 1;
    flex-basis: auto;
    margin: 0 0 0 -1px !important;
    padding: 0 1em !important;
    text-align: center;
    border-left: 1px solid #ccc;
}

.input[disabled] {
  @at-root .test-class-replace-1#{&} {
    opacity: 0.2;
    }
}

main {
  .text-flex {
    display: flex;
    justify-content: space-between;
  }
}

.result {
  .padding-top-bottom {
    padding: 7px 0 7px 0;
  }
}

.or {
  top: 12.5%;
  position: relative;
}

form {
  .box-text {
    min-height: calc(.75rem * 1.5);
  }
}

.search-button-container {
  padding-top: 15px;
  padding-bottom: 30px;
}

.search-results-container {
  padding: 0.5em 0 2.5em 0;
}

ul#list-cirlces {
  list-style-type: disc;
  list-style-position: inside;
  padding: 0 30px 0 30px;
  list-style-position: outside;
}
</style>
